const loading_card = {
	description: "This may take a few minutes",
	title: "Your VPS is being created...",
};

export default loading_card;
